import React, { FC, PropsWithChildren, useRef, useState } from 'react';

import { CSSTransition } from 'react-transition-group';

import './Tooltip.scoped.scss';

interface Props {
  content: string;
  className?: string;
  position?: 'top' | 'bottom' | 'left';
}

const Tooltip: FC<PropsWithChildren<Props>> = (props) => {
  const { content, children, className, position = 'top' } = props;

  const [active, setActive] = useState(false);
  const timeoutRef = useRef(0);

  const onClick = () => {
    clearTimeout(timeoutRef.current);
    setActive(true);
  };

  const onLeave = () => {
    timeoutRef.current = window.setTimeout(() => {
      setActive(false);
    }, 250);
  };

  const getClassNames = () => {
    let styles = ['app-tooltip__answer'];
    if (position === 'bottom') styles.push('app-tooltip__position_bottom');
    if (position === 'left') styles.push('app-tooltip__position_left');
    if (className) styles.push(className);
    return styles.join(' ');
  };

  return (
    <div className="app-tooltip" onClick={onClick} onMouseLeave={onLeave}>
      {children}
      <CSSTransition in={active} timeout={250} classNames="app-tooltip__answer-" unmountOnExit>
        <div className={getClassNames()}>
          <div className="app-tooltip__text">{content}</div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default Tooltip;
